import { Action } from '@ngrx/store';
import { ManageBusinessData, BusinessUnitManageResponse } from '@app/api/models/api-models';

export enum AuthActionTypes {
  MANAGE_BUSINESS_ATTEMPT = '[Auth] Manaege Business Attempt',
  MANAGE_BUSINESS_FAILURE = '[Auth] Manaege Business Failure',
  MANAGE_BUSINESS_SUCCESS = '[Auth] Manaege Business Success',

  ERROR_LAYOUT_SHOW = '[Error] show',
  ERROR_LAYOUT_HIDE = '[Error] hide',
  NAV_MENU_LAYOUT_SHOW = '[NavMenu] show',
  NAV_MENU_LAYOUT_HIDE = '[NavMenu] hide',
  CHANGE_LANGUAGE = '[Auth] Change Language',

  BUSINESS_FROM_HYDRA = '[BusinessFromHydra] Business From Hydra',
}

export class ManageBusinessAttempt implements Action {
  readonly type = AuthActionTypes.MANAGE_BUSINESS_ATTEMPT;
  constructor(public payload: ManageBusinessData) {}
}

export class ManageBusinessSuccess implements Action {
  readonly type = AuthActionTypes.MANAGE_BUSINESS_SUCCESS;
  constructor(public payload: { manageResponse: BusinessUnitManageResponse }) {}
}

export class ManageBusinessFailure implements Action {
  readonly type = AuthActionTypes.MANAGE_BUSINESS_FAILURE;
  constructor(public payload: { error: any }) {}
}

export class ErrorLayoutShow implements Action {
  readonly type = AuthActionTypes.ERROR_LAYOUT_SHOW;
  constructor(public payload: { error: any }) {}
}

export class ErrorLayoutHide implements Action {
  readonly type = AuthActionTypes.ERROR_LAYOUT_HIDE;
  constructor(public payload: any) {}
}

export class NavMenuLayoutShow implements Action {
  readonly type = AuthActionTypes.NAV_MENU_LAYOUT_SHOW;
}

export class NavMenuLayoutHide implements Action {
  readonly type = AuthActionTypes.NAV_MENU_LAYOUT_HIDE;
}

export class ChangeLanguage implements Action {
  readonly type = AuthActionTypes.CHANGE_LANGUAGE;
  constructor(public payload: any) {}
}

export class BusinessFromHydra implements Action {
  readonly type = AuthActionTypes.BUSINESS_FROM_HYDRA;
  constructor(public payload?: { isBusinessFromHydra: boolean }) {}
}

export type AuthActions =
  | ManageBusinessAttempt
  | ManageBusinessSuccess
  | ManageBusinessFailure
  | ErrorLayoutShow
  | ErrorLayoutHide
  | NavMenuLayoutShow
  | NavMenuLayoutHide
  | ChangeLanguage
  | BusinessFromHydra;
